import React from "react";
import {
  Box,
  Stack,
  Container,
  ListItem,
  Text,
  Heading,
  OrderedList,
  Link,
} from "@chakra-ui/react";
import { PageContainer } from "../src/components/ui/PageContainer";
import { GetStaticProps } from "next";
import { HeroWrapper } from "../src/components/ContentPages/HeroWrapper";
import { Layout } from "../src/components/Layout";

export default function TermsAndConditions() {
  return (
    <Layout
      pageTitle={"mentorlab | Allgemeine Geschäfts- und Teilnahmebedingungen"}
      pageDescription={
        "Wir helfen dem Mittelstand auf dem Weg in die Neue Wirtschaft - kompetent, kompakt, kollaborativ"
      }
      og={{
        currentRelativeUrlPath: "/terms-and-conditions",
        siteName: "mentorlab | Pre-Launch Nutzungsbedingungen",
      }}
    >
      <PageContainer>
        <Container maxW={"7xl"} mt={10}>
          <HeroWrapper
            title={"Allgemeine Geschäfts- und Teilnahmebedingungen"}
            subTitle={
              "mentorlab strebt einen gemeinsamen Nutzen aller Plattformteilnehmer an und setzt deshalb auf das wohlwollende Mitwirken aller Beteiligten. Nachfolgend sind einige wesentliche Aspekte der Teilnahme an mentorlab formuliert. Um das Lesen zu erleichtern, sind mit „Nutzer“, „Mentor“ o.a. immer und ausdrücklich alle Geschlechter angesprochen. Stand: Dezember 2022."
            }
            imgUrl={"/mission.svg"}
            imgAltText={"mentorlab terms and conditions illustration"}
          />
          <Stack alignItems="center" spacing={10}>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §1 Gegenstand
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  mentorlab, Leopoldstr. 256 (c/o MST Group), 80807 München,
                  vertreten durch Florian Birnkammer, Alexander Sattler und Mike
                  Schertl (im Folgenden &quot;mentorlab&quot;) betreibt unter
                  www.mentorlab.de, eine Plattform zur Vermittlung,
                  Ausschreibung und Buchung von Trainings, Workshops, Vorträgen
                  und Beratungsleistungen rund um das Thema Digitale
                  Transformation bzw. Business Transformation. Auf dieser
                  Plattform können haupt- oder nebenberufliche Coaches, Berater
                  und Trainer (im Folgenden &quot;Mentoren&quot; genannt) ihre
                  Profile und Angebote der Öffentlichkeit vorstellen.
                  Organisationen (im Folgenden &quot;Unternehmen&quot;) können
                  diese Angebote suchen und anfragen, bzw. zu einem späteren
                  Zeitpunkt auch buchen.
                </ListItem>
                <ListItem>
                  Ein Vertrag über die Nutzung von Diensten auf mentorlab.de
                  kommt mit der Registrierung und der Anmeldung des Nutzers am
                  System bzw. zum Zeitpunkt der Buchung einer kostenfreien oder
                  kostenpflichtigen Mitgliedschaft zustande. Mit dem Abschluss
                  eines Nutzungsvertrags erwirbt der Nutzer die
                  Zugangsberechtigung zu mentorlab.de.
                </ListItem>
                <ListItem>
                  mentorlab behält sich vor, die vorliegenden AGB jederzeit und
                  ohne Angabe von Gründen zu ändern, zu ergänzen bzw. neu zu
                  fassen. Über wesentliche Änderungen, Ergänzungen bzw.
                  Neufassungen der AGB wird der Nutzer vor deren Inkrafttreten
                  rechtzeitig im Voraus per Mail oder Hinweis auf der Plattform
                  informiert. Widerspricht der Nutzer nicht schriftlich
                  innerhalb von vier Wochen nach Zugang der Mitteilung über die
                  Änderung, Ergänzung bzw. Neufassung, gelten die geänderten AGB
                  als angenommen. Auf die Folge wird der Nutzer im Rahmen der
                  Mitteilung über die Änderung, Ergänzung oder Neufassung
                  hingewiesen. Akzeptiert der Nutzer die geänderten AGB nicht,
                  steht mentorlab ein Sonderkündigungsrecht mit einer Frist von
                  3 Monaten zu; mentorlab hat dieses innerhalb von 4 Wochen nach
                  Widerspruch des Nutzers auszuüben.
                </ListItem>
                <ListItem>
                  Der Nutzer stimmt zu, dass mentorlab ihn zu vertragsrelevanten
                  Themen, zu Zwecken der Qualitätssicherung und -verbesserung,
                  oder bei Aktualisierungen des Leistungsumfangs per Email
                  kontaktieren darf.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §2 Leistungsumfang der Informationsdienste
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Der Nutzer ist berechtigt, die von mentorlab angebotenen
                  Dienste nach Maßgabe folgender Bestimmungen zu benutzen.
                </ListItem>
                <ListItem>
                  Die Informationsdienste stellen dem Nutzer via einer
                  elektronischen Datenbank Informationen zur Verfügung. Diese
                  Informationen können teilweise nur anonym dargestellt
                  eingesehen werden.
                </ListItem>
                <ListItem>
                  Eine Gewährleistung für die ununterbrochene Bereithaltung der
                  Dienste kann von mentorlab nicht übernommen werden.
                  Insbesondere Arbeiten, die zu Wartungs- und
                  Datenspeicherungszwecken erforderlich sind, können zu
                  Unterbrechungen führen. Für die Dauer dieser
                  Unterbrechungszeit sowie einer angemessenen Vor- und
                  Nachlaufzeit ist mentorlab von der Verpflichtung zur Leistung
                  der Dienste befreit.
                </ListItem>
                <ListItem>
                  Bei höherer Gewalt und unvorhergesehenen Ereignissen wie
                  Feuer, Streik, Aussperrungen sowie sonstigen Umständen, die
                  von mentorlab nicht zu vertreten sind und die eine
                  Einschränkung oder Einstellung der Dienste von mentorlab
                  erforderlich machen, ist mentorlab für die Dauer der
                  Einschränkung oder Einstellung von der Pflicht zur Leistung
                  befreit. Höhere Gewalt ist ebenfalls gegeben, wenn mentorlab
                  in Folge eines unberechtigten Zugriffs Dritter, eines
                  andauernden Stromausfalls oder eines Computervirus im System
                  seine Leistungen einschränken oder einstellen muss und sich
                  nicht zu angemessenen Bedingungen gegen das Eintreten eines
                  derartigen Ereignisses schützen konnte.
                </ListItem>
                <ListItem>
                  Einige Funktionen sind kostenpflichtig und können nur bei
                  Abschluss einer Premium-Mitgliedschaft genutzt werden.
                </ListItem>
                <ListItem>
                  Nutzer dürfen zur Nutzung der Plattform nur jeweils einen
                  aktiven Account besitzen. Dieser muss unter Klarnamen und
                  unter wahrheitsgemäßer Angabe der erforderlichen
                  Registrierungsdaten erstellt und geführt werden.
                </ListItem>
                <ListItem>
                  mentorlab behält sich das Recht vor, Leistungen zu erweitern,
                  zu ändern und Verbesserungen vorzunehmen. mentorlab ist ferner
                  berechtigt, die Leistungen in einem zumutbaren Umfang zu
                  verringern.
                </ListItem>
                <ListItem>
                  Soweit mentorlab kostenlose Dienste und Leistungen erbringt,
                  können diese jederzeit und ohne Vorankündigung eingestellt
                  oder in kostenpflichtige Dienste umgewandelt werden.
                </ListItem>
                <ListItem>
                  Die Einstellung und Modifikationen kostenloser Dienste und
                  Leistungen führt vorbehaltlich der Bestimmungen in §6 nicht zu
                  einem Minderungs-, Erstattungs- oder Schadensersatzanspruch
                  des Nutzers.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §3 Inhalt der Informationsdienste
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  mentorlab behält sich bezüglich der Gestaltung, des Inhalts
                  und der Form der Informationsdienste redaktionelle Freiheit
                  vor. Insbesondere im Interesse der Aktualität der
                  Informationen oder bei einer allgemeinen Änderung des
                  Informationsbedarfes ist mentorlab berechtigt, Form und Inhalt
                  der Informationsdienste zu ändern. Diese Änderung darf nicht
                  zu Lasten des vertraglichen Umfangs und der mit der Vergütung
                  bezahlten Dienste geschehen. Aus den oben genannten Gründen
                  kann mentorlab insbesondere auch die Art der mit den
                  Informationsdiensten verbundenen Kommunikationsmöglichkeiten
                  und Datenbanken ändern.
                </ListItem>
                <ListItem>
                  Der Nutzer erkennt an, dass Informationen, die mentorlab von
                  Unternehmen und Mentoren bezieht, oder die von diesen in das
                  Informationssystem eingegeben wurden, mentorlab nicht
                  zurechenbar sind und von mentorlab auch nicht überprüft
                  werden.
                </ListItem>
                <ListItem>
                  Der Nutzer bestätigt, dass an Teilen der Dienste Schutzrechte
                  bestehen können. Der Nutzer verpflichtet sich, in den
                  Informationsdiensten enthaltene Urheberrechtsvermerke oder
                  andere Hinweise auf derartige Rechte weder zu entfernen noch
                  unkenntlich zu machen und die gegebenen Vorschriften der
                  Schutzrechtsinhaber für die Verwendung der Informationen
                  einzuhalten. Der Nutzer erkennt an, dass Unternehmen oder
                  Mentoren ihn von dem Empfang der Informationen ausschließen
                  können.
                </ListItem>
                <ListItem>
                  Der Nutzer stimmt ausdrücklich einer Weiterverarbeitung seiner
                  Daten, insbesondere Angaben zu den vom Nutzer gesuchten
                  Informationen und von ihm zu vermittelnden Projekten,
                  beziehungsweise Angaben zu seinem Profil, sowie deren
                  Weiterleitung zu. Die Weitergabe an aussenstehende Dritte zu
                  werblichen oder anderen Zwecken durch mentorlab ist
                  ausgeschlossen.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §4 Pflichten des Nutzers
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Der Nutzer ist verpflichtet, die Dienste von mentorlab
                  sachgerecht zu nutzen. Er ist insbesondere verpflichtet,
                  {/*@ts-ignore*/}
                  <ol type="a" style={{ "padding-left": "1rem" }}>
                    <ListItem>
                      einen nutzenstiftenden Betrieb der Plattform durch ein
                      qualitativ hochwertiges Mentorenprofil und relevante,
                      eigene Angebote zu unterstützen und alle eingehende
                      Anfragen von Unternehmen oder anderen
                      Plattformteilnehmern, sowie von mentorlab nach Möglichkeit
                      innerhalb von 2 Werktagen zu beantworten.
                    </ListItem>
                    <ListItem>
                      die Zugriffsmöglichkeit auf die mentorlab Dienste nicht
                      mißbräuchlich zu nutzen und rechtswidrige Handlungen zu
                      unterlassen;
                    </ListItem>
                    <ListItem>
                      die Erfüllung gesetzlicher Vorschriften und behördlicher
                      Auflagen sicherzustellen sowie für die Erteilung
                      behördlicher Erlaubnisse Sorge zu tragen, soweit diese
                      gegenwärtig oder künftig für die Teilnahme an mentorlab
                      Diensten erforderlich sein sollten;
                    </ListItem>
                    <ListItem>
                      den anerkannten Grundsätzen der Datensicherheit Rechnung
                      zu tragen, insbesondere Passwörter geheim zu halten bzw.
                      unverzüglich zu ändern oder Änderungen zu veranlassen,
                      falls die Vermutung besteht, dass nichtberechtigte Dritte
                      davon Kenntnis erlangt haben;
                    </ListItem>
                    <ListItem>
                      mentorlab erkennbare Mängel oder Schäden oder unrichtige
                      bzw. anstößige Angaben unverzüglich anzuzeigen
                      (Störungsmeldung);
                    </ListItem>
                    <ListItem>
                      ausschließlich wahrheitsgemäße Angaben zu verwenden bzw.
                      zu veröffentlichen. Bei Zuwiderhandeln behält sich
                      mentorlab die Deaktivierung des Accounts, sowie den
                      dauerhaften Ausschluss des betreffenden Nutzers von der
                      Benutzung der Plattform vor. Bei Verdachtsfällen, zum
                      Beispiel bei Meldung eines Profils oder Angebotes durch
                      andere Nutzer, kann mentorlab den Zugriff und die Nutzung
                      bis zur Klärung des Sachverhaltes befristetet
                      einschränken.
                    </ListItem>
                    <ListItem>
                      als Mentor im Rahmen der Formularvorgaben ausschließlich
                      vollständige, aussagekräftige und inhaltlich richtige
                      Profile und Angebote mit einem nachvollziehbaren und
                      konkreten Bezug zum Thema Digitale oder Business
                      Transformation zu veröffentlichen.
                    </ListItem>
                    <ListItem>
                      als Unternehmen vollständige, aussagekräftige und
                      verbindliche Ausschreibungen zur Veröffentlichung auf dem
                      Job Board einzugeben. mentorlab behält sich vor, Profile,
                      Angebote und Ausschreibungen nicht zu veröffentlichen,
                      wenn diese nicht den in g) und h) genannten
                      Qualitätsanforderungen entsprechen.
                    </ListItem>
                    <ListItem>
                      als Nutzer der Plattform auf Anfrage von mentorlab zeitnah
                      und wahrheitsgemäß Auskunft über das Zustandekommen von
                      Aufträgen zu geben.
                    </ListItem>
                  </ol>
                </ListItem>
                <ListItem>
                  Adressänderungen des Nutzers sind mentorlab unverzüglich
                  mitzuteilen. Leistungsstörungen oder die Nichterbringung von
                  Leistungen, zu denen mentorlab nach dem zwischen ihr und dem
                  Nutzer geschlossenen Vertrag verpflichtet ist, sind nicht von
                  mentorlab zu vertreten, wenn sie auf einer verspäteten
                  Mitteilung über die geänderte Adresse eines Nutzers beruhen.
                </ListItem>
                <ListItem>
                  Verstößt der Nutzer gegen die in § 4 Absatz 1 genannten
                  Pflichten, ist mentorlab berechtigt, das Vertragsverhältnis
                  vorbehaltlich der Geltendmachung von Schadensersatzansprüchen
                  ohne Einhaltung einer Frist zu kündigen.
                </ListItem>
                <ListItem>
                  Der Nutzer ist für alle Genehmigungen und Erlaubnisse, die
                  notwendig sind, um die Dienste zu empfangen, selbst
                  verantwortlich. Der Nutzer wird nur solche Daten und
                  Informationen abrufen und entgegennehmen, zu deren
                  Entgegennahme er nach den getroffenen Vereinbarungen
                  berechtigt ist.
                </ListItem>
                <ListItem>
                  Weiterhin ist der Nutzer verpflichtet, die Dienste und die
                  darin enthaltenen Informationen nur innerhalb seines Vertrages
                  und für eigene Zwecke zu nutzen. Der Nutzer verpflichtet sich,
                  die Dienste nicht für rechtswidrige Zwecke zu verwenden oder
                  eine Verwendung dafür zu gestatten.
                </ListItem>
                <ListItem>
                  Unternehmen ist es insbesondere nicht gestattet, Mentoren
                  Leistungen anzubieten, welche zu den Diensten von mentorlab in
                  Konkurrenz stehen, insbesondere aber nicht ausschließlich das
                  Angebot zur Aufnahme in die eigene Datenbank sowie über die
                  zukünftige Zusendung von Projektangeboten direkt durch das
                  Unternehmen.
                </ListItem>
                <ListItem>
                  Massen-Nachrichten, Multilevel Marketing (MLM), das Versenden
                  von Spam-Nachrichten sowie vergleichbare Aktivitäten sind
                  allen Plattformteilnehmern ausdrücklich untersagt.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §5 Externe Links
              </Heading>
              <Text>
                mentorlab.de enthält Links zu Webseiten, die von anderen
                Anbietern betrieben werden. mentorlab kontrolliert solche
                Webseiten, sofern die Linkeinbindung durch mentorlab selbst
                vorgenommen wurde, bei Aufnahme des Links und ist für geänderte
                Inhalte nicht verantwortlich. Links, die von Nutzern der
                Plattform erstellt werden, können lediglich stichprobenartig
                kontrolliert werden. Aus diesen Gründen distanziert sich
                mentorlab ausdrücklich von allen Inhalten aller gelinkten Seiten
                und macht sich diese Inhalte ausdrücklich nicht zu eigen. Diese
                Erklärung gilt für alle auf der Plattform angebrachten Links und
                eingebundenen Frames.
              </Text>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §6 Gewährleistung
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  mentorlab wird alles unternehmen, um auf die Richtigkeit und
                  Vollständigkeit veröffentlichter Informationen hinzuwirken und
                  die Genauigkeit und Zuverlässigkeit der Dienste
                  sicherzustellen.
                </ListItem>
                <ListItem>
                  mentorlab übernimmt keine Gewährleistung dafür, dass die in
                  den Informationsdiensten enthaltenen Informationen richtig,
                  vollständig und umfassend sind.
                </ListItem>
                <ListItem>
                  Weitergehende Gewährleistungsansprüche mit Ausnahme von
                  Ansprüchen wegen Fehlens zugesicherter Eigenschaften sind
                  ausgeschlossen, die Bestimmungen in § 7 bleiben unberührt.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §7 Haftung
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Schadensersatzansprüche aus Unmöglichkeit der Leistung,
                  positiver Forderungsverletzung, Verschulden bei
                  Vertragsschluss und unerlaubter Handlung sind sowohl gegenüber
                  mentorlab wie auch im Verhältnis zu deren Erfüllungs- und
                  Verrichtungsgehilfen ausgeschlossen, soweit nicht Ansprüche
                  aus der Verletzung des Lebens, des Körpers, der Gesundheit
                  oder aus der Verletzung wesentlicher Vertragspflichten
                  (Kardinalspflichten) oder wegen vorsätzlichen oder grob
                  fahrlässigen Handelns vorliegen.
                </ListItem>
                <ListItem>
                  mentorlab haftet weder für die Vollständigkeit, Richtigkeit
                  oder Aktualität der über die Dienste übermittelten
                  Informationen und fremden Inhalte noch dafür, dass diese frei
                  von Rechten Dritter sind und schuldet insbesondere keinen
                  Vermittlungserfolg.
                </ListItem>
                <ListItem>
                  mentorlab haftet nicht für etwaige Schäden, die dadurch
                  entstehen, dass die Informationen des Nutzers auf den
                  technischen Übertragungswegen, die in der Regel durch die
                  Internet-Service-Provider (ISP) und Netzbetreiber wie die
                  Deutsche Telekom AG gestellt werden, eingesehen werden können.
                </ListItem>
                <ListItem>
                  mentorlab haftet nicht für den Missbrauch der
                  Informationsdienste durch andere Nutzer. Der Nutzer stellt
                  mentorlab von Schadenersatzansprüchen Dritter frei, die sich
                  aus der Bereitstellung der Informationsdienste an die Nutzer
                  oder die Verwendung der Informationsdienste durch die Nutzer
                  ergeben, sofern diese Ansprüche nicht auf einer
                  Verletzungshandlung eines gesetzlichen Vertreters oder
                  Erfüllungsgehilfen von mentorlab beruhen.
                </ListItem>
                <ListItem>
                  mentorlab haftet in keinem Fall für Verluste des Nutzers, die
                  aufgrund von fehlender, unrichtiger oder zeitlich verzögerter
                  Übermittlung von Informationen durch die Informationsdienste
                  von mentorlab eingetreten sind.
                </ListItem>
                <ListItem>
                  Der Nutzer haftet für alle Folgen und Nachteile, die mentorlab
                  und Dritten durch die missbräuchliche oder rechtswidrige
                  Verwendung Dienste von mentorlab oder dadurch entstehen, dass
                  der Nutzer seinen sonstigen Obligationen nicht nachkommt. Er
                  ist insbesondere verpflichtet, nach Abgabe einer
                  Störungsmeldung gem. § 4 Ziff. 1. e. mentorlab die durch
                  Überprüfung ihrer Einrichtungen entstandenen Aufwendungen zu
                  ersetzen, wenn und soweit sich nach der Prüfung herausstellt,
                  dass eine Störung im Verantwortungsbereich des Nutzers vorlag.
                </ListItem>
                <ListItem>
                  Bei Verstößen gegen die Verbotsnorm in § 4 Ziff. 8 ist
                  mentorlab berechtigt, von dem Nutzer Schadensersatz in Höhe
                  des ihr entstandenen Schadens und zur Deckung der
                  erforderlichen Aufwendungen zur Schadensbeseitigung zu
                  fordern.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §8 Zahlungsbedingungen
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Die vereinbarte Vergütung entsprechend der jeweils allgemein
                  gültigen Preisliste ist nach Wahl des Nutzers im
                  Zahlungsintervall jeweils jährlich nach Rechnungsstellung im
                  Voraus fällig. Die Mindestlaufzeit für die
                  Premium-Mitgliedschaft beträgt ein Jahr und verlängert sich um
                  ein weiteres Jahr, wenn diese nicht spätestens 4 Wochen vor
                  Ablauf der Kündigungsfrist gekündigt wird.
                </ListItem>
                <ListItem>
                  Die vereinbarte Vergütung zuzüglich der darauf zu berechnenden
                  Umsatzsteuer ist fristgerecht zu zahlen. Für jeden nicht
                  eingelösten Scheck oder jede nicht eingelöste bzw.
                  zurückgereichte Lastschrift hat der Nutzer mentorlab die
                  entstandenen pauschalierten Kosten in Höhe von 10,00 € zu
                  erstatten.
                </ListItem>
                <ListItem>
                  In den hier genannten Vergütungen für Informationsdienste von
                  mentorlab sind die Kosten für die Nutzung von
                  Telefonleistungen und Datennetzen sowie sonstige Leistungen
                  der Datenübertragungsmedien als auch die etwaigen Kosten für
                  weitere Gebühren oder Leistungen von Fremdanbietern, wie den
                  Internetprovidern oder Netzbetreibern wie bspw. der Deutschen
                  Telekom AG, nicht enthalten.
                </ListItem>
                <ListItem>
                  mentorlab kann jederzeit unter Einhaltung einer Frist von vier
                  Wochen durch schriftliche Anzeige die Vergütung für die
                  nutzerbezogenen Informationsdienste in einem marktüblichen
                  Umfang erhöhen.
                </ListItem>
                <ListItem>
                  Der Nutzer ist damit einverstanden, soweit erforderlich,
                  Rechnungen auf elektronischem Wege zu erhalten.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §9 Zahlungsverzug
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Kommt der Nutzer mit der Bezahlung des Entgeltes in Verzug,
                  ist mentorlab berechtigt,den Zugang zu sperren, Verzugszinsen
                  in Höhe von 4% über dem jeweiligen Diskontsatz der Deutschen
                  Bundesbank zu berechnen, es sei denn, dass mentorlab eine
                  höhere Zinslast nachweist, das Vertragsverhältnis fristlos zu
                  kündigen.
                </ListItem>
                <ListItem>
                  Die Geltendmachung weiterer Ansprüche wegen Zahlungsverzuges
                  bleibt mentorlab vorbehalten.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §10 Aufrechnungs- und Zurückbehaltungsrecht
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Liefer- und Leistungsverzögerungen aufgrund von Störungen oder
                  eines Ausfalls von Kommunikationsnetzen und Gateways der
                  Internetprovider oder Netzbetreibern wie der Deutschen Telekom
                  AG hat mentorlab auch bei verbindlich vereinbarten Fristen und
                  Terminen nicht zu vertreten. Diese berechtigen mentorlab, die
                  Lieferung bzw. Leistung um die Dauer der Belieferung,
                  zuzüglich einer angemessenen Anlaufzeit, hinauszuschieben.
                </ListItem>
                <ListItem>
                  Bei Ausfällen von Diensten wegen einer außerhalb des
                  Verantwortungsbereiches von mentorlab liegenden Störung
                  erfolgt keine Rückvergütung. Im Übrigen werden Ausfallzeiten
                  durch Laufzeitverlängerung ausgeglichen. Eine Haftung gem. §7
                  Abs. 1 und 2 bleibt unberührt.
                </ListItem>
                <ListItem>
                  Eine Aufrechnung oder ein Zurückbehaltungsrecht des Nutzers
                  ist nur möglich, wenn dessen Forderungen gegen mentorlab
                  unbestritten sind oder rechtskräftig festgestellt werden.
                  Jegliche Zurückhaltung von Zahlungen ist ausgeschlossen, wenn
                  der Zurückbehaltungsanspruch auf einem anderen
                  Vertragsverhältnis beruht.
                </ListItem>
                <ListItem>
                  Unberührt weitergehender Ansprüche ist mentorlab dazu
                  berechtigt, die Übermittlung der Informationsdienste oder
                  eines Teiles davon an den Nutzer einzustellen, ohne dass
                  dadurch die Zahlungsverpflichtungen des Nutzers aufgehoben
                  werden, wenn der Nutzer wesentliche Verpflichtungen aus diesem
                  Vertrag im Hinblick auf die Nutzung der Informationsdienste
                  verletzt. Dies schließt auch Verpflichtungen aus § 11 ein.
                  mentorlab wird dem Nutzer den Empfang der Informationsdienste
                  wieder ermöglichen, wenn die ordnungsgemäße Erfüllung seiner
                  vertraglichen Pflichten sichergestellt ist.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §11 Nutzung durch Dritte
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Der Nutzer ist über den gemäß § 4 Absatz 5 gewährten Umfang
                  nicht berechtigt, die Informationen der Dienste insgesamt oder
                  einzelne Informationen daraus an Dritte weiterzugeben oder zur
                  Nutzung zu überlassen oder in sonstiger Weise zu verbreiten
                  oder zu veröffentlichen. Dritte im oben genannten Sinne sind
                  auch solche Personen oder Unternehmen, an denen der Nutzer
                  direkt oder indirekt beteiligt ist oder die in seinem
                  Alleineigentum stehen. Bei einem Verstoß gegen diese
                  Bestimmungen hat der Nutzer vorbehaltlich weitergehender
                  Schadensersatzansprüche den durch den Dritten erzielten
                  Nutzungswert mentorlab zu erstatten.
                </ListItem>
                <ListItem>
                  Der Nutzer versichert, mit den von ihm bezogenen Informationen
                  weder zu handeln, noch sie gewerbsmäßig weiterzuverarbeiten
                  und dies auch Dritten nicht zu gestatten. Die Einbindung oder
                  Weiterleitung eigener Inhalte (Mentoren-Profil, Angebote oder
                  Ausschreibungen) beispielsweise über die eigene Website oder
                  Social Media-Dienste ist davon ausgenommen.
                </ListItem>
                <ListItem>
                  Bei Pflichtverstößen gemäß § 11 Absätze 1 bis 2 ist mentorlab
                  zur sofortigen Vertragsbeendigung berechtigt.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §12 Vertragsfrist und Vertragsbeendigung
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Der Vertrag für den Bezug der Informationsdienste wird auf
                  unbestimmte Zeit geschlossen und ist mit einer Frist von 4
                  Wochen vor Ende der Vertragslaufzeit kündbar. Ohne Kündigung
                  verlängert sich der Vertrag erneut um seine Vertragslaufzeit,
                  längstens jedoch um 12 Monate.
                </ListItem>
                <ListItem>
                  Die Kündigung kann von beiden Parteien erfolgen, entweder
                  durch Nutzung des Online-Formulars, per E-Mail an{" "}
                  <Link
                    textDecor={"underline"}
                    href="mailto:kontakt@mentorlab.de"
                  >
                    kontakt@mentorlab.de
                  </Link>{" "}
                  oder in Schriftform.
                </ListItem>
                <ListItem>
                  mentorlab ist unbeschadet weitergehender Ansprüche berechtigt,
                  diesen Vertrag fristlos und ohne dass sich daraus Rechte des
                  Nutzers ergeben können zu kündigen, falls der Nutzer
                  wesentliche Vertragspflichten, insbesondere die in § 11
                  beschriebenen Verpflichtungen oder seine Verpflichtung zur
                  Zahlung der Vergütung nach § 8 verletzt. Gleiches gilt, wenn
                  der Nutzer sonstige vertragliche Verpflichtungen, insbesondere
                  die in § 4 genannten Pflichten, verletzt. mentorlab ist
                  berechtigt, diesen Vertrag fristlos zu kündigen, falls der
                  Nutzer durch seine Teilnahme am Empfang der
                  Informationsdienste Störungen in der Datenbank oder den
                  Informationsträgern bei mentorlab hervorruft.
                </ListItem>
                <ListItem>
                  Freistellungsansprüche und Rechtsverzichte zugunsten mentorlab
                  bleiben über das Ende dieses Vertrages hinaus wirksam.
                </ListItem>
                <ListItem>
                  Bereits gezahlte Gebühren werden im Falle einer Kündigung
                  nicht zurückerstattet.
                </ListItem>
              </OrderedList>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §13 Geheimhaltung
              </Heading>
              <Text>
                Falls nicht ausdrücklich schriftlich etwas anderes vereinbart
                ist, gelten die an mentorlab unterbreiteten Informationen,
                insbesondere Angaben zu seinem Profil, als nicht vertraulich.
              </Text>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §14 Gerichtsstand
              </Heading>
              <Text>
                Bei Kaufleuten im Sinne des Handelsrechts und alle anderen
                Nutzer, die eine wirksame Gerichtsstandsvereinbarung treffen
                können, ist Gerichtsstand für alle mit mentorlab abgeschlossenen
                Verträge München.
              </Text>
            </Box>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" size="md" mb={5}>
                §15 Schlussbestimmungen
              </Heading>
              <OrderedList my={5}>
                <ListItem>
                  Diese Allgemeinen Geschäftsbedingungen dienen als Grundlage
                  jeglicher Vertragsabschlüsse mit mentorlab. Gegenbestätigungen
                  des Nutzers unter Hinweis auf seine Geschäfts- bzw.
                  Einkaufsbedingungen wird hiermit ausdrücklich widersprochen.
                </ListItem>
                <ListItem>
                  Keine Partei darf die ihr nach diesem Vertrag zustehenden
                  Rechte ohne vorherige Zustimmung der jeweils anderen Partei an
                  Dritte abtreten.
                </ListItem>
                <ListItem>
                  Deutsches Recht unter Ausschluss des deutschen Internationalen
                  Privatrechts sowie des UN-Kaufrechts gilt als vereinbart.
                </ListItem>
              </OrderedList>
            </Box>

            <Box maxW="3xl" w="100%">
              <Heading as="h2" size="md" mb={5}>
                § 16 Anschrift
              </Heading>
              <Text fontWeight={"bold"}>mentorlab</Text>
              <br />
              <Text>
                Leopoldstr. 256
                <br /> c/o MST Group
                <br />
                80807 München
                <br />
                Deutschland
                <br />
                E-Mail:{" "}
                <Link
                  textDecor={"underline"}
                  href="mailto:kontakt@mentorlab.de"
                >
                  info@mentorlab.de
                </Link>
                <br />
                <br />
                Vertretungsberechtigte Personen:
                <br />
                Florian Birnkammer, Alexander Sattler, Mike Schertl
              </Text>
            </Box>
          </Stack>
        </Container>
      </PageContainer>
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async (_context) => {
  return {
    props: {},
  };
};
